import PresupuestosEstadisticas from './PresupuestosEstadisticas';

export default PresupuestosEstadisticas;
